/***********************************************
 *  Entry point dell'applicativo
 *  in base alle variabili d'ambiente
 *  decidiamo se startare o no il mock service worker
 *
 **********************************************/

const startMockServer = async () => {
  const { worker } = await import('mocks/browser');
  worker.start({
    serviceWorker: { url: '/mockServiceWorker.js' },
    onUnhandledRequest: 'bypass',
  });
};
export const usingMockServer = () =>
  import.meta.env.DEV && !!import.meta.env.VITE_APP_USE_MOCK_SERVER;

export const initFN = async () => {
  if (usingMockServer()) await startMockServer();
};
